module.exports = __webpack_public_path__ + "static/media/fushifaru_app_loader.d47b029e.jpg";